<template>
  <section class="form-section">
    <q-form ref="formContractData">
      <div class="title-page">Dados do contrato</div>
      <div class="group-input q-mt-lg flex justify-between">
        <div
          :class="!isShownContractNumberById ? 'col-12 full-width' : 'col-4'"
        >
          <label for="code_city">Cód. da Cidade</label>
          <q-select
            id="code_city"
            class="col-12 q-mt-sm full-width"
            outlined
            dense
            v-model="contract.codeCity"
            color="red-9"
            @filter="filterCodCities"
            use-input
            hide-selected
            fill-input
            input-debounce="0"
            :options="optionsItensFiltered.optionsCodCity"
            @update:model-value="getCityByCodeCity()"
            option-value="value"
            option-label="value"
            bg-color="white"
            :rules="[(val) => !!val || 'Campo Obrigatório']"
            lazy-rules
          />
        </div>
        <div class='col-7' v-if="isShownContractNumberById">
          <label for="contract_number">Nº do Contrato</label>
          <q-input
            class="col-4 q-mt-sm"
            id="contract_number"
            v-model="contract.contractNumber"
            bg-color="white"
            color="red-9"
            maxlength="10"
            dense
            outlined
            placeholder="0000000000"
            :rules="[(val) => !!val || 'Campo Obrigatório']"
            lazy-rules
          />
        </div>
      </div>
      <div class="group-input q-mt-md">
        <label v-if="typeOs.os_type === '12'" for="city">Cidade em atendimento</label>
        <label v-else for="city">Cidade</label>
        <q-select
          id="city"
          class="q-mt-sm"
          outlined
          dense
          v-model="contract.city"
          color="red-9"
          use-input
          hide-selected
          fill-input
          input-debounce="0"
          :options="optionsItensFiltered.optionsCity"
          @filter="filterCities"
          option-value="value"
          option-label="text"
          bg-color="white"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>
      <!-- <div class="group-input q-mt-md" v-if="typeOs.os_type === '4'">
        <label for="city">Para qual contrato a OS será gerada?</label>
        <q-input
          class="q-mt-sm"
          id="contract_number"
          v-model="contract.contractOs"
          bg-color="white"
          color="red-9"
          maxlength="10"
          dense
          outlined
          placeholder="0000000000"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          lazy-rules
        />
      </div> -->
    </q-form>
  </section>
</template>

<script>
import { computed, ref } from "vue";

export default {
  name: "ContractData",
  props: {
    contract: Object,
    optionsItens: Object,
    typeOs: Number,
  },
  setup(props) {
    let city = ref();
    let formContractData = ref(null);
    let citiesAvailable = ["235", "487"];
    let optionsItensFiltered = ref({
      optionsCity:props.optionsItens.optionsCity,
      optionsCodCity: props.optionsItens.optionsCodCity,
    });
    const shownContractNumberById = ["1"];
    let isShownContractNumberById = computed(() => {
      return !shownContractNumberById.includes(props.typeOs.os_type);
    });

    function getCityByCodeCity() {
      props.contract.city = props.contract.codeCity;
    }

    async function validateForm() {
      return await formContractData.value.validate();
    }

    function filterCodCities(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        optionsItensFiltered.value.optionsCodCity = props.optionsItens.optionsCodCity.filter(
          (v) => v.value.toLowerCase().indexOf(needle) > -1
        );
      });
    }

  function filterCities(val, update) {
    update(() => {
      if (val === "") {
        optionsItensFiltered.value.optionsCity = props.optionsItens.optionsCity;
        return;
      }
    });

    update(() => {
      const needle = val.toLowerCase();
      optionsItensFiltered.value.optionsCity = props.optionsItens.optionsCity.filter(
        (v) => v.text.toLowerCase().indexOf(needle) > -1
      );
    });
  }

    const isHiddenFieldsByOsType = computed(() => {
      const hiddenOsTypes = ['4'];
      return !hiddenOsTypes.includes(props.typeOs.os_type);
    });

    const getCity = computed(() => {
      // return props.optionsItens.optionsCity.filter((item) =>
      //   citiesAvailable.includes(item.value)
      // );
      return props.optionsItens.optionsCity;
    });

    const getCodCity = computed(() => {
      // return props.optionsItens.optionsCodCity.filter((item) =>
      //   citiesAvailable.includes(item.value)
      // );
       return props.optionsItens.optionsCodCity
    });

    return {
      formContractData,
      optionsItensFiltered,
      getCity,
      getCodCity,
      getCityByCodeCity,
      filterCodCities,
      filterCities,
      validateForm,
      isHiddenFieldsByOsType,
      isShownContractNumberById,
      shownContractNumberById,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-section {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.title-page {
  font-size: 1rem;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: red;
  margin: 0;
}
label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>
